import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeProfileQueryKey } from './queryKey';
export const useGetEmployeeProfiles = () => {
    const intl = useIntl();
    return useQuery([EmployeeProfileQueryKey.EmployeeProfiles], () => api.base.get('/api/employeeProfile/Overview').then(res => res.data), {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export const useGetEmployeeProfilesForSelect = () => {
    const intl = useIntl();
    return useQuery([EmployeeProfileQueryKey.EmployeeProfilesForSelect], () => api.base.get('/api/employeeProfile/Get').then(res => res.data), {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
